/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import { type ForwardedRef, createContext, forwardRef } from 'react';
import { type ContextValue, Provider, TextField as TextFieldCore, type TextFieldProps as TextFieldCoreProps, useContextProps } from 'react-aria-components';
import { HintContext } from '../hint/hint.component';
import { InputStyleContext } from '../input/input.component';
import { LabelContext, type LabelProps } from '../label/label.component';

interface TextFieldStyleProps {
  /** The size variant of the text field. (Default: 48) */
  size?: keyof typeof sizeVariants;
  style?: stylex.StyleXStyles;
}

type TextFieldProps = Omit<TextFieldCoreProps, 'style' | 'className'> & TextFieldStyleProps;

const TextFieldStyleContext = createContext<ContextValue<TextFieldStyleProps, HTMLDivElement>>({});

const TextField = forwardRef((props: TextFieldProps, ref: ForwardedRef<HTMLDivElement>) => {
  [props, ref] = useContextProps(props, ref, TextFieldStyleContext);

  const { style, children, size = 48, ...coreProps } = props;

  return (
    <TextFieldCore ref={ref} {...stylex.props(styles.base, sizeVariants[size], style)} {...coreProps}>
      {(renderProps) => (
        <Provider values={[
          [LabelContext, { size: LABEL_SIZES[size] }],
          [InputStyleContext, { size }],
          [HintContext, { style: hintSizeVariants[size] }]
        ]}>
          {typeof children === 'function' ? children?.(renderProps) : children}
        </Provider>
      )}
    </TextFieldCore>
  );
});

const LABEL_SIZES: Record<keyof typeof sizeVariants, LabelProps['size']> = {
  48: 16,
  32: 13,
};

const styles = stylex.create({
  base: {
    display: 'flex',
    flexDirection: 'column'
  },
});

const sizeVariants = stylex.create({
  48: { gap: 6 },
  32: { gap: 4 }
});

const hintSizeVariants = stylex.create({
  48: { marginTop: -2 },
  32: {}
});

export { TextField, TextFieldStyleContext, type TextFieldProps, type TextFieldStyleProps };
